import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import Logo from "../../Images/Logo.svg";
import { HiMenu } from "react-icons/hi";
import { IoIosLogOut } from "react-icons/io";
import useLogout from "../../Redux/actions/logout";
import { dashboardData } from "../../Data/Data";

const Sidebar = () => {
  const [toggle, setToggle] = useState(false);
  const [greeting, setGreeting] = useState("Hello");

  const user = useSelector((state) => state.auth.user);
  const logout = useLogout();

  const toggleHandler = () => {
    setToggle(!toggle);
  };

  const capitalizeFirstLetter = (str) => {
    return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
  };

  const firstName = user?.name ? capitalizeFirstLetter(user.name.split(" ")[0]) : "Guest";

  const getGreeting = () => {
    const hours = new Date().getHours();
    if (hours < 12) {
      return "Good Morning";
    } else if (hours < 18) {
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  };

  useEffect(() => {
    setGreeting(getGreeting());
  }, []);

  return (
    <div
      style={{ width: toggle ? "250px" : "50px" }}
      className="sticky top-0 bottom-0 h-[100vh] shadow-xl transition-all duration-300 bg-white"
    >
      <div className="flex justify-between items-center px-1 mt-6">
        <div style={{ display: toggle ? "flex" : "none" }} className="w-[80px]">
          <img src={Logo} alt="" className="w-full" />
        </div>
        <div className="cursor-pointer" onClick={toggleHandler}>
          <HiMenu className="text-3xl text-navBg" />
        </div>
      </div>

      <div
        style={{ display: toggle ? "block" : "none" }}
        className="mx-3 mt-6 mb-3 font-semibold text-lg text-navBg"
      >
        {greeting}, {firstName} 👋
      </div>

      <div className="flex flex-col justify-center items-start gap-6 mt-8 px-1">
        {dashboardData?.map((item) => (
          <NavLink
            to={item.path}
            key={item.id}
            className={({ isActive }) =>
              `p-2 w-full rounded-lg flex justify-start items-center gap-4 transition-all ${
                isActive
                  ? "bg-navBg text-white"
                  : "text-navBg hover:text-white hover:bg-navBg"
              }`
            }
            end
          >
            <div
              style={{ display: toggle ? "flex" : "none" }}
              className="hidden lg:flex font-Poppins font-semibold"
            >
              {item.name}
            </div>
            <div
              style={{ fontSize: toggle ? "20px" : "25px" }}
              className="relative text-xl"
            >
              {item.icon}
            </div>
          </NavLink>
        ))}
        <button
          onClick={logout}
          className="p-2 w-full rounded-lg flex justify-start items-center gap-4 transition-all text-navBg hover:text-white hover:bg-navBg"
        >
          <div
            style={{ display: toggle ? "flex" : "none" }}
            className="hidden lg:flex font-Poppins font-semibold"
          >
            Logout
          </div>
          <div
            style={{ fontSize: toggle ? "20px" : "25px" }}
            className="relative text-xl"
          >
            <IoIosLogOut />
          </div>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
